import * as _ from 'lodash-es';
import React, { useCallback, useRef } from 'react';
import { useLinkAssetTokenToQuill } from './AssetTokenContext';
import attachmentSizeExceededToast from './attachmentSizeExceededToast';
import imageSizeExceededToast from './imageSizeExceededToast';
import { useNamespaceFormats } from './NamespaceFormatsProvider';
import type QuillComponentProps from './QuillComponentProps';
import ReactQuill from './ReactQuill';
import { FILE_OVERSIZED_ERROR, IMAGE_OVERSIZED_ERROR } from './Uploader';
import useIsPublicView from '../utils/useIsPublicView';
import useShowEditorToast from './utils/useShowEditorToast';

const QuillComponent = ({
  namespace,
  initialContent,
  content,
  onMount,
  ...props
}: QuillComponentProps) => {
  const showEditorToast = useShowEditorToast();
  const isPublicView = useIsPublicView();
  const initialContentRef = useRef(initialContent);
  const namespaceFormats = useNamespaceFormats();

  const handleUploadError = useCallback(
    (message: string) => {
      if (message === FILE_OVERSIZED_ERROR) {
        showEditorToast(attachmentSizeExceededToast);
      } else if (message === IMAGE_OVERSIZED_ERROR) {
        showEditorToast(imageSizeExceededToast);
      } else {
        showEditorToast({ message, level: 'error' });
      }
    },
    [showEditorToast],
  );

  const linkAssetTokenToQuill = useLinkAssetTokenToQuill();

  return (
    <ReactQuill
      {...props}
      onMount={(quill) => {
        linkAssetTokenToQuill(quill);
        onMount?.(quill);
      }}
      moduleConfig={_.merge(
        { clipboard: { publicView: isPublicView } },
        props.moduleConfig,
      )}
      content={content ?? initialContentRef.current}
      onUploadError={handleUploadError}
      formats={namespaceFormats[namespace]}
    />
  );
};

export default QuillComponent;
